import apiClient from './apiClient';

export async function listUsers(params = {}) {
  const { data } = await apiClient.get('/api/admin/users', { params });
  return data;
}
